/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRulePercentageCalculate extends models.BillingRuleCalculate {
    constructor() {
        super();
        this.setDiscriminator("BillingRulePercentageCalculate");
    }

    getFixupPrototypeFunction() { return BillingRulePercentageCalculate.fixupPrototype; }

    static newInstance(model: Partial<BillingRulePercentageCalculate>): BillingRulePercentageCalculate {
        let obj = Object.assign(new BillingRulePercentageCalculate(), model);
        BillingRulePercentageCalculate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRulePercentageCalculate>): BillingRulePercentageCalculate {
        if (!model) return null;
        return BillingRulePercentageCalculate.newInstance(<BillingRulePercentageCalculate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRulePercentageCalculate) {
        if (!obj) return;

        models.BillingRulePercentageCalculate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRulePercentageCalculate): boolean {
        if (models.BillingRuleCalculate.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRulePercentageCalculate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.percentage === undefined) {
            this.percentage = 0;
        }
    }

    /**
     * Percentage of the billing rule
     */
    percentage: number;

}
